import { c as _c } from "react/compiler-runtime";
// Иконки действий: скачать, поделиться, скрыть, фильтр, сортировка, правка, удаление, счётчики из Figma «OSMIX ЛК Покупателя» (cHkTZXVaiia41bQ9HlRF7O),
// выгрузка SVG 02.10.2026. Цвет — currentColor (задаётся text-*), размер — проп size.
// Файл собран скриптом из audit/DS/icons-svg: правьте рисунок там и пересобирайте.
import { type IconProps, Svg } from "./icon";

/** Скачать: действия идеи. Figma: «download 3 / Size=L · 24». */
export function DownloadIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12.0073 3C12.5596 3 13.0073 3.44772 13.0073 4L13.0073 12.9815L16.3027 9.98402C16.7113 9.6124 17.3437 9.64234 17.7154 10.0509C18.087 10.4594 18.057 11.0919 17.6485 11.4635L12.6802 15.9827C12.2987 16.3297 11.7159 16.3297 11.3344 15.9827L6.36618 11.4635C5.95763 11.0919 5.92769 10.4594 6.29931 10.0509C6.67093 9.64234 7.30339 9.6124 7.71194 9.98402L11.0073 12.9815L11.0073 4C11.0073 3.44772 11.455 3 12.0073 3ZM2.00781 20.003C2.00781 19.4507 2.45553 19.003 3.00781 19.003L21.0078 19.003C21.5601 19.003 22.0078 19.4507 22.0078 20.003C22.0078 20.5553 21.5601 21.003 21.0078 21.003L3.00781 21.003C2.45553 21.003 2.00781 20.5553 2.00781 20.003Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Скачать в кнопке L. Figma: «download 3 / Size=M · 20». */
export function Download20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10.0087 2.5C10.469 2.5 10.842 2.8731 10.842 3.33333L10.842 10.8179L13.5882 8.32002C13.9287 8.01034 14.4557 8.03528 14.7654 8.37575C15.0751 8.71621 15.0501 9.24325 14.7097 9.55294L10.5694 13.3189C10.2515 13.6081 9.76588 13.6081 9.44798 13.3189L5.30776 9.55294C4.96729 9.24325 4.94234 8.71621 5.25203 8.37575C5.56171 8.03528 6.08876 8.01034 6.42922 8.32002L9.17538 10.8179L9.17538 3.33333C9.17538 2.8731 9.54848 2.5 10.0087 2.5ZM1.67578 16.6691C1.67578 16.2089 2.04888 15.8358 2.50911 15.8358L17.5091 15.8358C17.9694 15.8358 18.3424 16.2089 18.3424 16.6691C18.3424 17.1294 17.9694 17.5025 17.5091 17.5025L2.50911 17.5025C2.04888 17.5025 1.67578 17.1294 1.67578 16.6691Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Загрузить в кнопке M/S (отзыв, документы). Figma: «download 3 / Size=S · 16». */
export function Download16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.00619 2C8.37438 2 8.67286 2.29848 8.67286 2.66667L8.67285 8.65435L10.8698 6.65602C11.1421 6.40827 11.5638 6.42823 11.8115 6.7006C12.0593 6.97297 12.0393 7.3946 11.767 7.64235L8.45477 10.6551C8.20045 10.8865 7.81192 10.8865 7.5576 10.6551L4.24542 7.64235C3.97305 7.3946 3.95309 6.97297 4.20084 6.7006C4.44859 6.42823 4.87023 6.40827 5.1426 6.65602L7.33952 8.65435L7.33952 2.66667C7.33952 2.29848 7.638 2 8.00619 2ZM1.33984 13.3353C1.33984 12.9671 1.63832 12.6686 2.00651 12.6686L14.0065 12.6687C14.3747 12.6687 14.6732 12.9671 14.6732 13.3353C14.6732 13.7035 14.3747 14.002 14.0065 14.002L2.00651 14.002C1.63832 14.002 1.33984 13.7035 1.33984 13.3353Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Поделиться: действия идеи. Figma: «share 3 / Size=L · 24». */
export function ShareIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M15.7049 1.99707L21.0907 1.99707C21.3559 1.99707 21.6103 2.10244 21.7978 2.29C21.9854 2.47756 22.0907 2.73193 22.0907 2.99717L22.0902 8.46522C22.0901 9.01751 21.6424 9.46518 21.0901 9.46513C20.5378 9.46507 20.0901 9.01731 20.0902 8.46503L20.0905 5.41165L13.2956 12.2071C12.9051 12.5976 12.2719 12.5976 11.8814 12.2071C11.4909 11.8166 11.4908 11.1834 11.8813 10.7929L18.6766 3.99707H15.7049C15.1526 3.99707 14.7049 3.54936 14.7049 2.99707C14.7049 2.44479 15.1526 1.99707 15.7049 1.99707ZM7.7587 2.99998L10.5556 2.99999C11.1078 2.99999 11.5556 3.4477 11.5556 3.99999C11.5556 4.55227 11.1078 4.99999 10.5556 4.99999H7.8C6.94342 4.99999 6.36113 5.00076 5.91104 5.03754C5.47262 5.07336 5.24842 5.13828 5.09202 5.21797C4.7157 5.40972 4.40973 5.71568 4.21799 6.092C4.1383 6.2484 4.07337 6.47261 4.03755 6.91102C4.00078 7.36111 4 7.94341 4 8.79998V16.2C4 17.0566 4.00078 17.6389 4.03755 18.0889C4.07337 18.5274 4.1383 18.7516 4.21799 18.908C4.40973 19.2843 4.7157 19.5903 5.09202 19.782C5.24842 19.8617 5.47262 19.9266 5.91104 19.9624C6.36113 19.9992 6.94342 20 7.8 20H15.2C16.0566 20 16.6389 19.9992 17.089 19.9624C17.5274 19.9266 17.7516 19.8617 17.908 19.782C18.2843 19.5903 18.5903 19.2843 18.782 18.908C18.8617 18.7516 18.9266 18.5274 18.9624 18.0889C18.9992 17.6389 19 17.0566 19 16.2V13.4444C19 12.8921 19.4477 12.4444 20 12.4444C20.5523 12.4444 21 12.8921 21 13.4444V16.2413C21 17.0463 21 17.7106 20.9558 18.2518C20.9099 18.8139 20.8113 19.3306 20.564 19.8159C20.1805 20.5686 19.5686 21.1805 18.816 21.564C18.3306 21.8113 17.8139 21.9099 17.2518 21.9558C16.7106 22 16.0463 22 15.2413 22H7.75868C6.95372 22 6.28936 22 5.74817 21.9558C5.18608 21.9099 4.66937 21.8113 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.8159C2.18868 19.3306 2.09012 18.8139 2.04419 18.2518C1.99998 17.7106 1.99999 17.0463 2 16.2413V8.75869C1.99999 7.95371 1.99998 7.28935 2.04419 6.74816C2.09012 6.18606 2.18868 5.66936 2.43597 5.18402C2.81947 4.43138 3.43139 3.81945 4.18404 3.43596C4.66937 3.18867 5.18608 3.0901 5.74817 3.04418C6.28937 2.99996 6.95373 2.99997 7.7587 2.99998Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Поделиться в кнопке L (карточка товара). Figma: «share 3 / Size=M · 20». */
export function Share20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M13.0887 1.66406L17.5769 1.66406C17.7979 1.66406 18.0099 1.75187 18.1662 1.90817C18.3225 2.06447 18.4102 2.27645 18.4102 2.49748L18.4098 7.05419C18.4097 7.51443 18.0366 7.88749 17.5764 7.88744C17.1161 7.8874 16.7431 7.51426 16.7431 7.05403L16.7434 4.50955L11.081 10.1724C10.7555 10.4978 10.2279 10.4979 9.90246 10.1724C9.57701 9.84701 9.57699 9.31937 9.90241 8.99392L15.5652 3.33073H13.0887C12.6285 3.33073 12.2554 2.95763 12.2554 2.4974C12.2554 2.03716 12.6285 1.66406 13.0887 1.66406ZM6.46689 2.49982L8.7976 2.49982C9.25784 2.49982 9.63093 2.87292 9.63093 3.33316C9.63093 3.7934 9.25784 4.16649 8.7976 4.16649H6.5013C5.78749 4.16649 5.30224 4.16714 4.92717 4.19778C4.56182 4.22763 4.37499 4.28174 4.24465 4.34815C3.93105 4.50794 3.67608 4.7629 3.51629 5.07651C3.44988 5.20684 3.39578 5.39368 3.36593 5.75902C3.33528 6.1341 3.33464 6.61934 3.33464 7.33316V13.4998C3.33464 14.2136 3.33528 14.6989 3.36593 15.074C3.39578 15.4393 3.44988 15.6261 3.51629 15.7565C3.67608 16.0701 3.93105 16.325 4.24465 16.4848C4.37499 16.5512 4.56182 16.6053 4.92717 16.6352C5.30224 16.6658 5.78749 16.6665 6.5013 16.6665H12.668C13.3818 16.6665 13.867 16.6658 14.2421 16.6352C14.6075 16.6053 14.7943 16.5512 14.9246 16.4848C15.2382 16.325 15.4932 16.0701 15.653 15.7565C15.7194 15.6261 15.7735 15.4393 15.8033 15.074C15.834 14.6989 15.8346 14.2136 15.8346 13.4998V11.2035C15.8346 10.7433 16.2077 10.3702 16.668 10.3702C17.1282 10.3702 17.5013 10.7433 17.5013 11.2035V13.5343C17.5013 14.2051 17.5013 14.7587 17.4645 15.2097C17.4262 15.6781 17.3441 16.1087 17.138 16.5131C16.8184 17.1403 16.3085 17.6503 15.6813 17.9698C15.2768 18.1759 14.8462 18.2581 14.3778 18.2963C13.9268 18.3332 13.3732 18.3332 12.7024 18.3332H6.46687C5.79607 18.3332 5.24244 18.3332 4.79145 18.2963C4.32303 18.2581 3.89245 18.1759 3.488 17.9698C2.86079 17.6503 2.35086 17.1403 2.03128 16.5131C1.82521 16.1087 1.74307 15.6781 1.7048 15.2097C1.66795 14.7587 1.66796 14.205 1.66797 13.5342V7.29874C1.66796 6.62793 1.66795 6.0743 1.7048 5.6233C1.74307 5.15489 1.82521 4.7243 2.03128 4.31986C2.35086 3.69265 2.86079 3.18271 3.488 2.86314C3.89245 2.65706 4.32303 2.57492 4.79145 2.53665C5.24244 2.49981 5.79608 2.49981 6.46689 2.49982Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Поделиться в кнопке S (корзина). Figma: «share 3 / Size=S · 16». */
export function Share16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10.4687 1.33105L14.0592 1.33105C14.236 1.33105 14.4056 1.4013 14.5306 1.52634C14.6556 1.65138 14.7259 1.82096 14.7258 1.99779L14.7255 5.64316C14.7254 6.01135 14.4269 6.30979 14.0587 6.30976C13.6906 6.30972 13.3921 6.01122 13.3921 5.64303L13.3923 3.60744L8.86243 8.13771C8.60209 8.39807 8.17998 8.39809 7.91962 8.13775C7.65927 7.87741 7.65925 7.4553 7.91959 7.19494L12.4498 2.66439H10.4687C10.1005 2.66439 9.80199 2.36591 9.80199 1.99772C9.80199 1.62953 10.1005 1.33105 10.4687 1.33105ZM5.17116 1.99966L7.03574 1.99966C7.40393 1.99966 7.7024 2.29814 7.7024 2.66633C7.7024 3.03452 7.40393 3.333 7.03574 3.333H5.1987C4.62765 3.333 4.23945 3.33352 3.93939 3.35803C3.64711 3.38191 3.49764 3.4252 3.39338 3.47832C3.1425 3.60615 2.93852 3.81013 2.81069 4.06101C2.75756 4.16528 2.71428 4.31475 2.6904 4.60702C2.66588 4.90708 2.66537 5.29528 2.66537 5.86633V10.7997C2.66537 11.3707 2.66588 11.7589 2.6904 12.059C2.71428 12.3512 2.75756 12.5007 2.81069 12.605C2.93852 12.8559 3.14249 13.0598 3.39338 13.1877C3.49764 13.2408 3.64711 13.2841 3.93939 13.308C4.23945 13.3325 4.62765 13.333 5.1987 13.333H10.132C10.7031 13.333 11.0913 13.3325 11.3913 13.308C11.6836 13.2841 11.8331 13.2408 11.9374 13.1877C12.1882 13.0598 12.3922 12.8559 12.52 12.605C12.5732 12.5007 12.6164 12.3512 12.6403 12.059C12.6648 11.7589 12.6654 11.3707 12.6654 10.7997V8.96263C12.6654 8.59444 12.9638 8.29596 13.332 8.29596C13.7002 8.29596 13.9987 8.59444 13.9987 8.96263V10.8272C13.9987 11.3639 13.9987 11.8068 13.9692 12.1675C13.9386 12.5423 13.8729 12.8867 13.708 13.2103C13.4524 13.7121 13.0444 14.12 12.5427 14.3757C12.2191 14.5405 11.8746 14.6063 11.4999 14.6369C11.1391 14.6663 10.6962 14.6663 10.1596 14.6663H5.17115C4.63451 14.6663 4.19161 14.6663 3.83081 14.6369C3.45608 14.6063 3.11161 14.5405 2.78806 14.3757C2.28629 14.12 1.87834 13.7121 1.62268 13.2103C1.45782 12.8867 1.39211 12.5423 1.36149 12.1675C1.33202 11.8068 1.33202 11.3638 1.33203 10.8272V5.8388C1.33202 5.30215 1.33202 4.85924 1.36149 4.49845C1.39211 4.12372 1.45782 3.77925 1.62268 3.45569C1.87834 2.95392 2.28629 2.54598 2.78806 2.29031C3.11161 2.12545 3.45608 2.05974 3.83081 2.02913C4.19161 1.99965 4.63452 1.99966 5.17116 1.99966Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Поделиться (share 1) в кнопке. Figma: «share 1 / Size=M · 20». */
export function ShareAlt20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.44788 1.89168C9.76579 1.60251 10.2514 1.60251 10.5693 1.89168L14.7096 5.65764C15.05 5.96733 15.075 6.49437 14.7653 6.83483C14.4556 7.1753 13.9286 7.20024 13.5881 6.89056L10.8419 4.39265V11.8772C10.8419 12.3375 10.4689 12.7106 10.0086 12.7106C9.54838 12.7106 9.17528 12.3375 9.17528 11.8772V4.39265L6.42913 6.89056C6.08866 7.20024 5.56162 7.1753 5.25193 6.83483C4.94225 6.49437 4.9672 5.96733 5.30766 5.65764L9.44788 1.89168ZM2.50912 9.16658C2.96935 9.16658 3.34245 9.53967 3.34245 9.99991V13.4917C3.34245 14.2055 3.3431 14.6907 3.37374 15.0658C3.40359 15.4312 3.4577 15.618 3.5241 15.7483C3.68389 16.0619 3.93886 16.3169 4.25246 16.4767C4.3828 16.5431 4.56963 16.5972 4.93498 16.627C5.31005 16.6577 5.7953 16.6583 6.50912 16.6583L13.5091 16.6583C14.2229 16.6583 14.7082 16.6577 15.0833 16.6271C15.4486 16.5972 15.6354 16.5431 15.7658 16.4767C16.0794 16.3169 16.3343 16.0619 16.4941 15.7483C16.5605 15.618 16.6146 15.4312 16.6445 15.0658C16.6751 14.6907 16.6758 14.2055 16.6758 13.4917V9.99991C16.6758 9.53967 17.0489 9.16658 17.5091 9.16658C17.9694 9.16658 18.3424 9.53967 18.3424 9.99991V13.5261C18.3425 14.1969 18.3425 14.7505 18.3056 15.2015C18.2673 15.6699 18.1852 16.1005 17.9791 16.505C17.6596 17.1322 17.1496 17.6421 16.5224 17.9617C16.118 18.1678 15.6874 18.2499 15.219 18.2882C14.768 18.325 14.2144 18.325 13.5436 18.325L6.47468 18.325C5.80388 18.325 5.25025 18.325 4.79926 18.2882C4.33085 18.2499 3.90026 18.1678 3.49581 17.9617C2.86861 17.6421 2.35867 17.1322 2.03909 16.505C1.83302 16.1005 1.75088 15.6699 1.71261 15.2015C1.67576 14.7505 1.67577 14.1969 1.67578 13.5261L1.67578 9.99991C1.67578 9.53967 2.04888 9.16658 2.50912 9.16658Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Глаз: показать идею / пункт профиля. Figma: «eye / Size=L · 24». */
export function EyeIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M11.9989 6C6.70122 6 4.33209 9.34004 3.41455 11.1817C3.36264 11.2858 3.35411 11.3056 3.34388 11.3356C3.33171 11.3713 3.3103 11.4457 3.2754 11.6323C3.27618 11.6282 3.27615 11.6284 3.27561 11.6336C3.27448 11.6445 3.27112 11.6766 3.268 11.7354C3.26398 11.8111 3.26172 11.9036 3.26172 12C3.26172 12.0964 3.26398 12.1889 3.268 12.2646C3.27112 12.3234 3.27448 12.3555 3.27561 12.3664C3.27615 12.3716 3.27618 12.3718 3.2754 12.3677C3.3103 12.5543 3.33171 12.6287 3.34388 12.6644C3.35411 12.6944 3.36264 12.7142 3.41455 12.8183C4.33209 14.66 6.70122 18 11.9989 18C17.2966 18 19.6657 14.66 20.5833 12.8183C20.6352 12.7142 20.6437 12.6944 20.6539 12.6644C20.6661 12.6287 20.6875 12.5543 20.7224 12.3677C20.7216 12.3718 20.7217 12.3716 20.7222 12.3663C20.7233 12.3555 20.7267 12.3234 20.7298 12.2646C20.7338 12.1889 20.7361 12.0964 20.7361 12C20.7361 11.9036 20.7338 11.8111 20.7298 11.7354C20.7267 11.6766 20.7233 11.6445 20.7222 11.6337C20.7217 11.6284 20.7216 11.6282 20.7224 11.6323C20.6875 11.4457 20.6661 11.3713 20.6539 11.3356C20.6437 11.3056 20.6352 11.2858 20.5833 11.1817C19.6657 9.34004 17.2966 6 11.9989 6ZM1.62443 10.2898C2.71616 8.09852 5.63386 4 11.9989 4C18.364 4 21.2816 8.09852 22.3734 10.2898L22.3796 10.3023C22.4272 10.3976 22.4905 10.5247 22.5471 10.6906C22.6042 10.8581 22.6462 11.0397 22.6883 11.2646C22.7278 11.4757 22.7361 11.7814 22.7361 12C22.7361 12.2186 22.7278 12.5243 22.6883 12.7354C22.6462 12.9603 22.6042 13.1419 22.5471 13.3094C22.4905 13.4753 22.4272 13.6024 22.3796 13.6977L22.3734 13.7102C21.2816 15.9015 18.364 20 11.9989 20C5.63386 20 2.71617 15.9015 1.62443 13.7102C1.62238 13.7061 1.62031 13.702 1.6182 13.6977C1.57065 13.6024 1.50728 13.4754 1.45075 13.3094C1.39366 13.1419 1.35157 12.9603 1.30949 12.7354C1.27002 12.5243 1.26172 12.2186 1.26172 12C1.26172 11.7814 1.27002 11.4757 1.30949 11.2646C1.35157 11.0397 1.39366 10.8581 1.45075 10.6906C1.50728 10.5247 1.57065 10.3976 1.61819 10.3023C1.6203 10.298 1.62238 10.2939 1.62443 10.2898ZM11.9989 10C10.8943 10 9.99891 10.8954 9.99891 12C9.99891 13.1046 10.8943 14 11.9989 14C13.1035 14 13.9989 13.1046 13.9989 12C13.9989 10.8954 13.1035 10 11.9989 10ZM7.99891 12C7.99891 9.79086 9.78977 8 11.9989 8C14.208 8 15.9989 9.79086 15.9989 12C15.9989 14.2091 14.208 16 11.9989 16C9.78977 16 7.99891 14.2091 7.99891 12Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Глаз перечёркнутый: скрыть идею. Figma: «eye-off / Size=L · 24». */
export function EyeOffIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L17.3859 18.8001C15.9333 19.5266 14.1547 20 12 20C5.63495 20 2.71726 15.9015 1.62552 13.7102L1.61928 13.6977C1.57173 13.6024 1.50836 13.4753 1.45183 13.3094C1.39473 13.1418 1.35264 12.9602 1.31056 12.7352C1.2711 12.5242 1.26281 12.2184 1.26283 11.9998C1.26284 11.7812 1.27116 11.4754 1.31065 11.2643C1.35277 11.0392 1.39493 10.8576 1.45214 10.6898C1.50875 10.5238 1.57221 10.3966 1.61988 10.3011C1.622 10.2968 1.62408 10.2927 1.62614 10.2885C2.17514 9.18694 3.18291 7.5986 4.87673 6.29095L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289ZM6.30536 7.71957C4.80099 8.81147 3.903 10.2038 3.41616 11.1806C3.36406 11.2852 3.3554 11.3051 3.34508 11.3354C3.33286 11.3712 3.31143 11.4457 3.27653 11.6322C3.27731 11.628 3.27728 11.6283 3.27674 11.6335C3.27561 11.6443 3.27224 11.6765 3.26912 11.7353C3.2651 11.8109 3.26283 11.9035 3.26283 11.9999C3.26282 12.0963 3.26508 12.1889 3.26909 12.2645C3.27221 12.3233 3.27556 12.3555 3.27669 12.3663C3.27724 12.3715 3.27726 12.3718 3.27649 12.3676C3.31138 12.5542 3.33279 12.6287 3.34496 12.6644C3.3552 12.6944 3.36373 12.7141 3.41565 12.8183C4.33318 14.66 6.70231 18 12 18C13.5367 18 14.8142 17.7215 15.8756 17.2899L14.0318 15.446C13.4363 15.7978 12.7411 16 12 16C9.79086 16 8 14.2091 8 12C8 11.2589 8.20225 10.5637 8.55396 9.96817L6.30536 7.71957ZM10.0676 11.4818C10.0235 11.6469 10 11.8206 10 12C10 13.1046 10.8954 14 12 14C12.1794 14 12.3531 13.9765 12.5182 13.9324L10.0676 11.4818ZM12 6C11.5809 6 11.1817 6.02072 10.8016 6.05941C10.2522 6.11533 9.76143 5.71525 9.70551 5.16581C9.64958 4.61636 10.0497 4.12561 10.5991 4.06969C11.0481 4.02399 11.5148 4 12 4C18.365 4 21.2827 8.09852 22.3745 10.2898L22.3807 10.3023C22.4283 10.3976 22.4917 10.5247 22.5482 10.6906C22.6053 10.8583 22.6474 11.0399 22.6895 11.2649L21.7065 11.4487L22.6895 11.2649C22.7289 11.4759 22.7372 11.7818 22.7372 12.0004C22.7371 12.219 22.7288 12.5249 22.6893 12.7359C22.6471 12.9611 22.6049 13.1429 22.5476 13.3108C22.4909 13.4769 22.4274 13.6042 22.3796 13.6999L22.3733 13.7125C22.101 14.2589 21.7188 14.9189 21.2001 15.6038C20.8666 16.0441 20.2394 16.1306 19.7991 15.7971C19.3589 15.4636 19.2723 14.8364 19.6058 14.3962C20.0375 13.8263 20.3565 13.2753 20.5834 12.8202C20.6357 12.7154 20.6444 12.6952 20.6548 12.6648C20.6671 12.629 20.6884 12.5547 20.7232 12.3692C20.7227 12.372 20.7227 12.3713 20.7232 12.3666C20.7244 12.3558 20.7277 12.3237 20.7309 12.2649C20.7349 12.1892 20.7372 12.0967 20.7372 12.0002C20.7372 11.9037 20.7349 11.8112 20.7309 11.7355C20.7278 11.6767 20.7244 11.6446 20.7233 11.6337C20.7228 11.6285 20.7227 11.6283 20.7235 11.6324C20.6886 11.4458 20.6672 11.3714 20.655 11.3356C20.6448 11.3056 20.6363 11.2859 20.5844 11.1817C19.6668 9.34004 17.2977 6 12 6Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Фильтр 24 (уведомления). Figma: «filter / Size=L · 24». */
export function FilterIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M2 6C2 5.44772 2.44772 5 3 5L21 5C21.5523 5 22 5.44772 22 6C22 6.55229 21.5523 7 21 7L3 7C2.44772 7 2 6.55228 2 6ZM5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12ZM8 18C8 17.4477 8.44772 17 9 17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Фильтр в кнопке «Фильтры» каталога. Figma: «filter / Size=S · 16». */
export function Filter16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 17 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M1.42525 4.28791C1.42394 3.89804 1.73892 3.58093 2.12879 3.57962L14.8353 3.5368C15.2252 3.53548 15.5423 3.85047 15.5436 4.24033C15.5449 4.6302 15.2299 4.94731 14.84 4.94863L2.13355 4.99145C1.74368 4.99276 1.42656 4.67778 1.42525 4.28791ZM3.55727 8.51627C3.55596 8.12641 3.87094 7.80929 4.26081 7.80798L12.7318 7.77943C13.1217 7.77812 13.4388 8.0931 13.4401 8.48297C13.4414 8.87283 13.1264 9.18995 12.7366 9.19126L4.26557 9.21981C3.8757 9.22112 3.55859 8.90614 3.55727 8.51627ZM5.6893 12.7446C5.68798 12.3548 6.00297 12.0377 6.39284 12.0363L10.6283 12.0221C11.0182 12.0208 11.3353 12.3357 11.3366 12.7256C11.3379 13.1155 11.023 13.4326 10.6331 13.4339L6.39759 13.4482C6.00773 13.4495 5.69061 13.1345 5.6893 12.7446Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 17 17" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Сортировка (sort-descending) справа от «Популярные». Figma: «sort-descending / Size=L · 24». */
export function SortIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M1 6C1 5.44772 1.44772 5 2 5L14 5C14.5523 5 15 5.44772 15 6C15 6.55229 14.5523 7 14 7L2 7C1.44772 7 1 6.55228 1 6ZM18.6436 8C19.1958 8 19.6436 8.44772 19.6436 9L19.6436 18.549L21.2929 16.8997C21.6834 16.5091 22.3166 16.5091 22.7071 16.8997C23.0976 17.2902 23.0976 17.9234 22.7071 18.3139L19.3507 21.6703C19.1631 21.8579 18.9088 21.9632 18.6436 21.9632C18.3783 21.9632 18.124 21.8579 17.9364 21.6703L14.58 18.3139C14.1895 17.9233 14.1895 17.2902 14.58 16.8997C14.9705 16.5091 15.6037 16.5091 15.9942 16.8997L17.6436 18.549L17.6436 9C17.6436 8.44772 18.0913 8 18.6436 8ZM1 12C1 11.4477 1.44772 11 2 11L11 11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H2C1.44772 13 1 12.5523 1 12ZM1 18C1 17.4477 1.44772 17 2 17L11 17C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19L2 19C1.44772 19 1 18.5523 1 18Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Редактировать. Figma: «edit 1 / Size=L · 24». */
export function EditIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3.22048 15.8313C3.23327 15.8185 3.24622 15.8056 3.25934 15.7924L17.0075 2.04452C18.3755 0.67645 20.5936 0.676457 21.9617 2.04453C23.3298 3.41262 23.3298 5.63073 21.9617 6.9988L8.21419 20.7461C8.20106 20.7592 8.1881 20.7722 8.17531 20.785C7.92905 21.0314 7.74279 21.2178 7.53141 21.3795C7.34459 21.5225 7.14552 21.6486 6.93652 21.7566C6.70004 21.8788 6.45202 21.9677 6.12411 22.0853C6.10708 22.0914 6.08983 22.0976 6.07236 22.1039L5.34859 22.3637C4.7742 22.5699 4.27959 22.7474 3.87944 22.8514C3.4887 22.9529 2.98755 23.0436 2.49182 22.8719C1.85442 22.6511 1.35356 22.15 1.13297 21.5126C0.961396 21.0168 1.0523 20.5157 1.15398 20.1249C1.2581 19.7248 1.43582 19.2303 1.6422 18.656C1.64743 18.6414 1.65267 18.6269 1.65793 18.6122L1.9022 17.9324C1.90847 17.915 1.91466 17.8977 1.92077 17.8807C2.03839 17.5531 2.12735 17.3053 2.24948 17.069C2.35742 16.8602 2.48355 16.6613 2.62642 16.4747C2.78806 16.2635 2.97429 16.0774 3.22048 15.8313ZM4.67354 17.2067C4.37214 17.5081 4.28586 17.5972 4.21462 17.6902C4.14319 17.7836 4.08012 17.883 4.02615 17.9874C3.97233 18.0915 3.92852 18.2076 3.78438 18.6087L3.54011 19.2885C3.31356 19.919 3.16797 20.3271 3.08951 20.6286C3.05113 20.7761 3.04098 20.8569 3.038 20.8917C3.05583 20.9232 3.08188 20.9492 3.11333 20.9671C3.1482 20.9641 3.22893 20.954 3.37644 20.9157C3.67796 20.8373 4.08612 20.6919 4.71671 20.4655L5.39672 20.2215C5.79822 20.0774 5.91436 20.0336 6.01858 19.9797C6.12308 19.9257 6.22261 19.8626 6.31602 19.7912C6.40918 19.7199 6.49835 19.6335 6.79999 19.3319L20.5475 5.58458C21.1345 4.99755 21.1345 4.04578 20.5475 3.45874C19.9604 2.87172 19.0087 2.87171 18.4217 3.45874L4.67354 17.2067Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Редактировать в поле (получатель). Figma: «edit 1 / Size=M · 20». */
export function Edit20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M2.67983 13.1927C2.69048 13.1821 2.70128 13.1713 2.71221 13.1604L14.169 1.70376C15.309 0.563709 17.1574 0.563714 18.2975 1.70378C19.4376 2.84385 19.4376 4.69227 18.2975 5.83234L6.84125 17.2884C6.83031 17.2994 6.81951 17.3102 6.80885 17.3208C6.60364 17.5262 6.44842 17.6815 6.27227 17.8162C6.11658 17.9354 5.95069 18.0405 5.77653 18.1305C5.57946 18.2323 5.37278 18.3064 5.09952 18.4044C5.08533 18.4095 5.07095 18.4147 5.05639 18.4199L4.45325 18.6364C3.97459 18.8082 3.56242 18.9562 3.22896 19.0428C2.90335 19.1274 2.48572 19.203 2.07261 19.0599C1.54145 18.8759 1.12406 18.4584 0.940232 17.9271C0.797257 17.514 0.873013 17.0964 0.95774 16.7708C1.04451 16.4374 1.19261 16.0252 1.3646 15.5467C1.36895 15.5345 1.37332 15.5224 1.3777 15.5102L1.58126 14.9437C1.58649 14.9291 1.59164 14.9148 1.59673 14.9006C1.69475 14.6276 1.76889 14.4211 1.87066 14.2242C1.96061 14.0502 2.06572 13.8844 2.18477 13.7289C2.31948 13.5529 2.47466 13.3978 2.67983 13.1927ZM3.89071 14.3389C3.63954 14.5901 3.56764 14.6643 3.50828 14.7419C3.44875 14.8196 3.39619 14.9025 3.35122 14.9895C3.30637 15.0763 3.26986 15.173 3.14975 15.5073L2.94619 16.0738C2.75739 16.5992 2.63607 16.9393 2.57069 17.1905C2.5387 17.3134 2.53024 17.3807 2.52776 17.4098C2.54262 17.436 2.56432 17.4577 2.59053 17.4726C2.6196 17.4701 2.68687 17.4617 2.8098 17.4297C3.06106 17.3644 3.4012 17.2432 3.92669 17.0546L4.49336 16.8512C4.82794 16.7311 4.92473 16.6946 5.01157 16.6498C5.09866 16.6048 5.1816 16.5522 5.25944 16.4926C5.33707 16.4332 5.41138 16.3613 5.66275 16.1099L17.119 4.65382C17.6082 4.16463 17.6082 3.37148 17.119 2.88229C16.6298 2.3931 15.8367 2.39309 15.3475 2.88228L3.89071 14.3389Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Удалить (корзина, способы оплаты). Figma: «trash 1 / Size=M · 20». */
export function TrashIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.88665 0.833047C9.92431 0.833068 9.96252 0.833088 10.0013 0.833088C10.0401 0.833088 10.0783 0.833068 10.116 0.833047C10.7788 0.832688 11.271 0.832422 11.6974 0.946669C12.8477 1.25489 13.7462 2.15338 14.0544 3.30369C14.123 3.55991 14.1503 3.83991 14.1611 4.16642H17.5013C17.9615 4.16642 18.3346 4.53952 18.3346 4.99975C18.3346 5.45999 17.9615 5.83309 17.5013 5.83309H16.668V14.3675C16.668 15.0383 16.668 15.592 16.6311 16.0429C16.5929 16.5114 16.5107 16.9419 16.3047 17.3464C15.9851 17.9736 15.4751 18.4835 14.8479 18.8031C14.4435 19.0092 14.0129 19.0913 13.5445 19.1296C13.0935 19.1664 12.5399 19.1664 11.8691 19.1664H8.13353C7.46273 19.1664 6.90911 19.1664 6.45811 19.1296C5.9897 19.0913 5.55911 19.0092 5.15467 18.8031C4.52746 18.4835 4.01752 17.9736 3.69795 17.3464C3.49187 16.9419 3.40973 16.5114 3.37146 16.0429C3.33462 15.5919 3.33462 15.0383 3.33464 14.3675L3.33464 5.83309H2.5013C2.04106 5.83309 1.66797 5.45999 1.66797 4.99975C1.66797 4.53952 2.04106 4.16642 2.5013 4.16642H5.84148C5.85226 3.83991 5.87956 3.55991 5.94822 3.30369C6.25644 2.15338 7.15493 1.25489 8.30524 0.946669C8.73162 0.832422 9.22383 0.832688 9.88665 0.833047ZM7.50952 4.16642L12.4931 4.16642C12.4854 3.95178 12.471 3.83405 12.4445 3.73506C12.2904 3.1599 11.8412 2.71066 11.266 2.55655C11.0808 2.50691 10.8299 2.49976 10.0013 2.49975C9.17267 2.49975 8.92184 2.50691 8.7366 2.55655C8.16145 2.71066 7.7122 3.1599 7.55809 3.73506C7.53157 3.83405 7.51717 3.95178 7.50952 4.16642ZM5.0013 5.83309V14.3331C5.0013 15.0469 5.00195 15.5321 5.0326 15.9072C5.06245 16.2726 5.11655 16.4594 5.18296 16.5897C5.34275 16.9033 5.59771 17.1583 5.91132 17.3181C6.04165 17.3845 6.22849 17.4386 6.59383 17.4685C6.96891 17.4991 7.45415 17.4998 8.16797 17.4998H11.8346C12.5485 17.4998 13.0337 17.4991 13.4088 17.4685C13.7741 17.4386 13.961 17.3845 14.0913 17.3181C14.4049 17.1583 14.6599 16.9033 14.8196 16.5897C14.8861 16.4594 14.9402 16.2726 14.97 15.9072C15.0007 15.5321 15.0013 15.0469 15.0013 14.3331V5.83309H5.0013Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Удалить в кнопке S (корзина). Figma: «trash 5 / Size=S · 16». */
export function Trash16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.33203 1.99502L4.99047 1.42251C4.67427 1.61115 4.57087 2.0204 4.75951 2.33659C4.9477 2.65203 5.35545 2.75569 5.67132 2.56889L5.67495 2.56681C5.67949 2.56422 5.68805 2.55941 5.70046 2.55268C5.7253 2.53921 5.76548 2.51813 5.81972 2.49191C5.92839 2.43938 6.09233 2.3668 6.30151 2.29351C6.72167 2.1463 7.31258 2.00033 7.9987 2.00033C8.68482 2.00033 9.27573 2.1463 9.69588 2.29351C9.90507 2.3668 10.069 2.43938 10.1777 2.49191C10.2319 2.51813 10.2721 2.53921 10.2969 2.55268C10.3094 2.55941 10.3179 2.56422 10.3224 2.56681L10.3258 2.56872L10.325 2.56825M5.33203 1.99502C4.99047 1.42251 4.99028 1.42261 4.99047 1.42251L4.99206 1.42156L4.99407 1.42037L4.99933 1.41729L5.01477 1.40839C5.02723 1.40129 5.04401 1.39189 5.06496 1.38054C5.10682 1.35784 5.16543 1.32725 5.23946 1.29146C5.38733 1.21998 5.59791 1.12722 5.86063 1.03518C6.38428 0.851702 7.12671 0.666992 7.9987 0.666992C8.87069 0.666992 9.61311 0.851702 10.1368 1.03518C10.3995 1.12722 10.6101 1.21998 10.7579 1.29146C10.832 1.32725 10.8906 1.35784 10.9324 1.38054C10.9534 1.39189 10.9702 1.40129 10.9826 1.40839L10.9981 1.41729L11.0033 1.42037L11.0053 1.42156L11.0062 1.42206C11.0064 1.42217 11.0069 1.42251 10.6654 1.99502L11.0069 1.42251C11.3231 1.61115 11.4265 2.0204 11.2379 2.33659C11.0497 2.65204 10.6417 2.75554 10.3258 2.56872M1.33203 4.00033C1.33203 3.63214 1.63051 3.33366 1.9987 3.33366H13.9987C14.3669 3.33366 14.6654 3.63214 14.6654 4.00033C14.6654 4.36852 14.3669 4.66699 13.9987 4.66699H13.332V11.4945C13.332 12.0312 13.332 12.4741 13.3026 12.8349C13.272 13.2096 13.2062 13.5541 13.0414 13.8776C12.7857 14.3794 12.3778 14.7873 11.876 15.043C11.5524 15.2079 11.208 15.2736 10.8332 15.3042C10.4725 15.3337 10.0296 15.3337 9.49291 15.3337H6.50448C5.96784 15.3337 5.52494 15.3337 5.16415 15.3042C4.78942 15.2736 4.44495 15.2079 4.12139 15.043C3.61962 14.7873 3.21168 14.3794 2.95601 13.8776C2.79115 13.5541 2.72544 13.2096 2.69483 12.8349C2.66535 12.4741 2.66536 12.0312 2.66536 11.4945L2.66536 4.66699H1.9987C1.63051 4.66699 1.33203 4.36852 1.33203 4.00033ZM3.9987 4.66699V11.467C3.9987 12.038 3.99922 12.4262 4.02373 12.7263C4.04761 13.0186 4.0909 13.168 4.14402 13.2723C4.27185 13.5232 4.47583 13.7272 4.72671 13.855C4.83098 13.9081 4.98045 13.9514 5.27272 13.9753C5.57278 13.9998 5.96098 14.0003 6.53203 14.0003H9.46536C10.0364 14.0003 10.4246 13.9998 10.7247 13.9753C11.017 13.9514 11.1664 13.9081 11.2707 13.855C11.5216 13.7272 11.7255 13.5232 11.8534 13.2723C11.9065 13.168 11.9498 13.0186 11.9737 12.7263C11.9982 12.4262 11.9987 12.038 11.9987 11.467V4.66699H3.9987Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Плюс 24 (карта ПВЗ, чат «+»). Figma: «plus 1 / Size=L · 24». */
export function PlusIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Плюс в кнопке L. Figma: «plus 2 / Size=M · 20». */
export function Plus20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10.0013 4.16699C10.4615 4.16699 10.8346 4.54009 10.8346 5.00033V9.16699H15.0013C15.4615 9.16699 15.8346 9.54009 15.8346 10.0003C15.8346 10.4606 15.4615 10.8337 15.0013 10.8337H10.8346V15.0003C10.8346 15.4606 10.4615 15.8337 10.0013 15.8337C9.54106 15.8337 9.16797 15.4606 9.16797 15.0003V10.8337H5.0013C4.54106 10.8337 4.16797 10.4606 4.16797 10.0003C4.16797 9.54009 4.54106 9.16699 5.0013 9.16699H9.16797V5.00033C9.16797 4.54009 9.54106 4.16699 10.0013 4.16699Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Плюс в кнопке M/S. Figma: «plus 2 / Size=S · 16». */
export function Plus16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.00065 3.33301C8.36884 3.33301 8.66732 3.63148 8.66732 3.99967V7.33301H12.0007C12.3688 7.33301 12.6673 7.63148 12.6673 7.99967C12.6673 8.36786 12.3688 8.66634 12.0007 8.66634H8.66732V11.9997C8.66732 12.3679 8.36884 12.6663 8.00065 12.6663C7.63246 12.6663 7.33398 12.3679 7.33398 11.9997V8.66634H4.00065C3.63246 8.66634 3.33398 8.36786 3.33398 7.99967C3.33398 7.63148 3.63246 7.33301 4.00065 7.33301H7.33398V3.99967C7.33398 3.63148 7.63246 3.33301 8.00065 3.33301Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Минус 24 (карта ПВЗ). Figma: «minus 1 / Size=L · 24». */
export function MinusIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Минус в кнопке L. Figma: «minus 2 / Size=M · 20». */
export function Minus20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M4.16797 10.0003C4.16797 9.54009 4.54106 9.16699 5.0013 9.16699H15.0013C15.4615 9.16699 15.8346 9.54009 15.8346 10.0003C15.8346 10.4606 15.4615 10.8337 15.0013 10.8337H5.0013C4.54106 10.8337 4.16797 10.4606 4.16797 10.0003Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Плюс счётчика количества в корзине. Figma: «Outline/Plus». */
export function PlusOutlineIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10 3.54199C10.3452 3.54199 10.625 3.82181 10.625 4.16699V15.8337C10.625 16.1788 10.3452 16.4587 10 16.4587C9.65482 16.4587 9.375 16.1788 9.375 15.8337V4.16699C9.375 3.82181 9.65482 3.54199 10 3.54199Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M3.54297 10C3.54297 9.65482 3.82279 9.375 4.16797 9.375H15.8346C16.1798 9.375 16.4596 9.65482 16.4596 10C16.4596 10.3452 16.1798 10.625 15.8346 10.625H4.16797C3.82279 10.625 3.54297 10.3452 3.54297 10Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Минус счётчика количества в корзине. Figma: «Outline/Minus». */
export function MinusOutlineIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3.54297 10C3.54297 9.65482 3.82279 9.375 4.16797 9.375H15.8346C16.1798 9.375 16.4596 9.65482 16.4596 10C16.4596 10.3452 16.1798 10.625 15.8346 10.625H4.16797C3.82279 10.625 3.54297 10.3452 3.54297 10Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Плюс в круге (параметры кастомизации). Figma: «Plus circle / Size=24». */
export function PlusCircleIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Минус в круге (параметры кастомизации). Figma: «Minus circle / Size=24». */
export function MinusCircleIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Крестик 24: закрыть фильтры, окна. Figma: «x 1 / Size=L · 24». */
export function XIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Крестик 16 в чипе фильтра. Figma: «x 1 / Size=S · 16». */
export function X16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 17 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3.74809 3.78082C4.02284 3.50421 4.4698 3.50271 4.7464 3.77745L8.49534 7.5012L12.2191 3.75227C12.4938 3.47566 12.9408 3.47416 13.2174 3.74891C13.494 4.02365 13.4955 4.47062 13.2208 4.74722L9.49702 8.49616L13.246 12.2199C13.5226 12.4947 13.5241 12.9416 13.2493 13.2182C12.9746 13.4948 12.5276 13.4963 12.251 13.2216L8.50207 9.49784L4.77832 13.2468C4.50357 13.5234 4.05661 13.5249 3.78 13.2501C3.50339 12.9754 3.50189 12.5284 3.77664 12.2518L7.50039 8.50288L3.75145 4.77913C3.47485 4.50439 3.47334 4.05742 3.74809 3.78082Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 17 17" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Крестик x 2 (компактный) 20: уведомления. Figma: «x 2 / Size=M · 20». */
export function XSmall20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.24408 5.24408C5.56951 4.91864 6.09715 4.91864 6.42259 5.24408L10 8.82149L13.5774 5.24408C13.9028 4.91864 14.4305 4.91864 14.7559 5.24408C15.0814 5.56951 15.0814 6.09715 14.7559 6.42259L11.1785 10L14.7559 13.5774C15.0814 13.9028 15.0814 14.4305 14.7559 14.7559C14.4305 15.0814 13.9028 15.0814 13.5774 14.7559L10 11.1785L6.42259 14.7559C6.09715 15.0814 5.56951 15.0814 5.24408 14.7559C4.91864 14.4305 4.91864 13.9028 5.24408 13.5774L8.82149 10L5.24408 6.42259C4.91864 6.09715 4.91864 5.56951 5.24408 5.24408Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Крестик x 2 16: очистить поле, чип фильтра. Figma: «x 2 / Size=S · 16». */
export function XSmall16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M4.19526 4.19526C4.45561 3.93491 4.87772 3.93491 5.13807 4.19526L8 7.05719L10.8619 4.19526C11.1223 3.93491 11.5444 3.93491 11.8047 4.19526C12.0651 4.45561 12.0651 4.87772 11.8047 5.13807L8.94281 8L11.8047 10.8619C12.0651 11.1223 12.0651 11.5444 11.8047 11.8047C11.5444 12.0651 11.1223 12.0651 10.8619 11.8047L8 8.94281L5.13807 11.8047C4.87772 12.0651 4.45561 12.0651 4.19526 11.8047C3.93491 11.5444 3.93491 11.1223 4.19526 10.8619L7.05719 8L4.19526 5.13807C3.93491 4.87772 3.93491 4.45561 4.19526 4.19526Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Галочка 24 (пуш «добавлено»). Figma: «check 1 / Size=L · 24». */
export function CheckIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M20.6961 5.2821C21.0926 5.66657 21.1024 6.29966 20.7179 6.69615L10.0512 17.6961C9.86289 17.8904 9.60389 18 9.33333 18C9.06278 18 8.80378 17.8904 8.61543 17.6961L3.2821 12.1961C2.89763 11.7997 2.90737 11.1666 3.30385 10.7821C3.70034 10.3976 4.33343 10.4074 4.7179 10.8039L9.33333 15.5635L19.2821 5.30385C19.6666 4.90737 20.2997 4.89763 20.6961 5.2821Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Галочка 20 (статус заказа). Figma: «check 1 / Size=M · 20». */
export function Check20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M17.2468 4.40208C17.5772 4.72247 17.5853 5.25004 17.2649 5.58045L8.37603 14.7471C8.21908 14.909 8.00324 15.0003 7.77778 15.0003C7.55232 15.0003 7.33648 14.909 7.17953 14.7471L2.73508 10.1638C2.41469 9.83338 2.42281 9.3058 2.75321 8.98541C3.08362 8.66502 3.61119 8.67313 3.93158 9.00354L7.77778 12.9699L16.0684 4.4202C16.3888 4.0898 16.9164 4.08168 17.2468 4.40208Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шестерёнка: настройки чатов. Figma: «settings 1 / Size=L · 24». */
export function SettingsIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M20.7682 13.07C20.5782 12.81 20.4882 12.51 20.4882 12.19C20.4882 11.88 20.5882 11.58 20.7682 11.32L21.6282 10.14C21.9982 9.63 22.2082 9.03 22.2482 8.39C22.2782 7.76 22.1282 7.14 21.8182 6.59C21.4982 6.04 21.0382 5.6 20.4782 5.32C19.9182 5.03 19.2882 4.92 18.6582 4.98L17.1982 5.13C16.8782 5.16 16.5782 5.1 16.3082 4.94C16.0382 4.78 15.8282 4.55 15.6982 4.26L15.0982 2.92C14.8382 2.34 14.4282 1.86 13.8982 1.51C13.3682 1.16 12.7582 1 12.1282 1C11.4882 1 10.8782 1.18 10.3482 1.53C9.81824 1.87 9.39824 2.36 9.14824 2.94L8.54824 4.28C8.41824 4.57 8.20824 4.8 7.94824 4.96C7.67824 5.12 7.36824 5.18 7.05824 5.15L5.59824 5C4.96824 4.93 4.33824 5.05 3.77824 5.34C3.21824 5.63 2.74824 6.07 2.43824 6.61C2.11824 7.14 1.96824 7.76 1.99824 8.39C2.02824 9.02 2.24824 9.62 2.61824 10.13L3.47824 11.31C3.66824 11.56 3.75824 11.86 3.75824 12.18C3.75824 12.5 3.65824 12.8 3.47824 13.05L2.61824 14.24C2.24824 14.75 2.03824 15.36 1.99824 15.99C1.95824 16.62 2.11824 17.24 2.42824 17.79C2.73824 18.34 3.20824 18.78 3.76824 19.06C4.32824 19.35 4.95824 19.46 5.58824 19.4L7.04824 19.24C7.35824 19.21 7.66824 19.27 7.93824 19.43C8.20824 19.59 8.41824 19.82 8.54824 20.11L9.13824 21.45C9.38824 22.03 9.80824 22.51 10.3382 22.86C10.8682 23.2 11.4782 23.39 12.1082 23.39C12.7382 23.39 13.3482 23.21 13.8782 22.86C14.4082 22.52 14.8182 22.03 15.0782 21.45L15.6682 20.11C15.7982 19.82 16.0082 19.59 16.2782 19.44C16.5482 19.28 16.8582 19.22 17.1682 19.25L18.6282 19.41C19.2582 19.48 19.8882 19.36 20.4482 19.07C21.0082 18.78 21.4782 18.34 21.7882 17.8C22.1082 17.25 22.2482 16.63 22.2182 16C22.1882 15.37 21.9682 14.77 21.5982 14.25L20.7382 13.07H20.7682ZM19.1482 14.24L20.0082 15.42C20.1482 15.62 20.2382 15.85 20.2482 16.09C20.2582 16.33 20.2082 16.57 20.0782 16.78C19.9582 16.99 19.7782 17.16 19.5582 17.27C19.3382 17.38 19.0982 17.43 18.8582 17.4L17.3982 17.24C16.6682 17.16 15.9382 17.32 15.2982 17.69C14.6582 18.06 14.1682 18.61 13.8682 19.28L13.2782 20.62C13.1782 20.84 13.0182 21.03 12.8182 21.16C12.4082 21.42 11.8582 21.42 11.4482 21.16C11.2382 21.03 11.0782 20.84 10.9882 20.62L10.3982 19.28C10.0982 18.6 9.59824 18.05 8.95824 17.68C8.31824 17.31 7.58824 17.15 6.85824 17.23L5.40824 17.38C5.16824 17.41 4.91824 17.36 4.70824 17.25C4.48824 17.14 4.30824 16.97 4.18824 16.76C4.06824 16.55 4.00824 16.31 4.01824 16.07C4.02824 15.83 4.11824 15.6 4.25824 15.4L5.11824 14.21C5.55824 13.61 5.78824 12.91 5.78824 12.17C5.78824 11.43 5.55824 10.72 5.11824 10.13L4.25824 8.94C4.11824 8.74 4.02824 8.51 4.01824 8.27C4.00824 8.03 4.05824 7.79 4.18824 7.58C4.30824 7.37 4.48824 7.2 4.70824 7.09C4.92824 6.98 5.16824 6.93 5.40824 6.96L6.86824 7.11C7.59824 7.18 8.32824 7.03 8.96824 6.66C9.60824 6.29 10.0982 5.74 10.3982 5.06L10.9982 3.72C11.0982 3.5 11.2582 3.31 11.4582 3.18C11.6582 3.05 11.8982 2.98 12.1382 2.98C12.4182 2.98 12.6182 3.05 12.8182 3.18C13.0182 3.31 13.1782 3.5 13.2782 3.73L13.8782 5.06C14.1782 5.74 14.6682 6.29 15.3082 6.66C15.9482 7.03 16.6782 7.18 17.4082 7.11L18.8682 6.96C19.1082 6.93 19.3582 6.98 19.5682 7.09C19.7882 7.2 19.9582 7.37 20.0882 7.58C20.2082 7.79 20.2682 8.03 20.2582 8.27C20.2482 8.51 20.1682 8.75 20.0182 8.94L19.1582 10.13C18.7182 10.73 18.4882 11.44 18.4882 12.17C18.4882 12.91 18.7082 13.62 19.1482 14.23V14.24Z" fill="currentColor" />;
    t3 = <path d="M12.1282 8.15C9.89824 8.15 8.08824 9.96 8.08824 12.19C8.08824 14.42 9.89824 16.23 12.1282 16.23C14.3582 16.23 16.1682 14.42 16.1682 12.19C16.1682 9.96 14.3582 8.15 12.1282 8.15ZM12.1282 14.23C10.9982 14.23 10.0882 13.31 10.0882 12.19C10.0882 11.07 11.0082 10.15 12.1282 10.15C13.2482 10.15 14.1682 11.07 14.1682 12.19C14.1682 13.31 13.2482 14.23 12.1282 14.23Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Шестерёнка залитая (лендинг продавца). Figma: «Bold/Setting». */
export function SettingBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M12.7168 2C13.4731 2 14.158 2.42007 14.5362 3.04004C14.7201 3.33993 14.8431 3.70976 14.8125 4.09961C14.7921 4.39961 14.8834 4.70047 15.0469 4.98047C15.5682 5.83035 16.7238 6.14989 17.6231 5.66992C18.6347 5.09027 19.9116 5.44004 20.4942 6.42969L21.1787 7.61035C21.7714 8.60033 21.4448 9.87045 20.4229 10.4404C19.5543 10.9505 19.2474 12.0805 19.7686 12.9404C19.9321 13.2103 20.1163 13.4401 20.4024 13.5801C20.7601 13.7701 21.0363 14.0701 21.2305 14.3701C21.6084 14.99 21.5778 15.75 21.21 16.4199L20.4942 17.6201C20.116 18.26 19.4111 18.6601 18.6856 18.6602C18.3281 18.6602 17.9295 18.5602 17.6026 18.3604C17.3369 18.1904 17.0301 18.1299 16.7032 18.1299C15.6914 18.1299 14.8432 18.9602 14.8125 19.9502C14.8124 21.0999 13.8723 21.9998 12.6973 22H11.3067C10.1214 21.9999 9.18178 21.1 9.18168 19.9502C9.16124 18.9602 8.31256 18.1299 7.30082 18.1299C6.9636 18.1299 6.65688 18.1904 6.4014 18.3604C6.07446 18.5602 5.66574 18.6601 5.3184 18.6602C4.5826 18.6602 3.87719 18.2601 3.49906 17.6201L2.79398 16.4199C2.41594 15.77 2.39546 14.9901 2.77348 14.3701C2.93694 14.0702 3.24351 13.7701 3.59086 13.5801C3.87696 13.4401 4.06168 13.2104 4.23539 12.9404C4.74637 12.0804 4.43901 10.9504 3.57035 10.4404C2.55879 9.87045 2.23221 8.60028 2.81449 7.61035L3.49906 6.42969C4.0918 5.43988 5.35903 5.09012 6.3809 5.66992C7.26989 6.14987 8.42504 5.83024 8.94633 4.98047C9.10984 4.70047 9.20212 4.39961 9.18168 4.09961C9.16133 3.70975 9.2737 3.33994 9.46781 3.04004C9.84595 2.42012 10.5304 2.02 11.2764 2H12.7168ZM12.0118 9.17969C10.4074 9.1797 9.10957 10.4399 9.10941 12.0098C9.10941 13.5798 10.4073 14.8301 12.0118 14.8301C13.6162 14.8301 14.8838 13.5798 14.8838 12.0098C14.8837 10.4399 13.6161 9.17969 12.0118 9.17969Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Три точки: меню заказа. Figma: «dots-horizontal / Size=L · 24». */
export function DotsHorizontalIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12ZM17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Три точки в круге: меню товара в корзине. Figma: «Outline/More Circle». */
export function MoreCircleIcon(t0) {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 30 : t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M19.9359 16.2676C19.2447 16.2676 18.6797 15.7088 18.6797 15.0176C18.6797 14.3263 19.2334 13.7676 19.9234 13.7676H19.9359C20.6272 13.7676 21.1859 14.3263 21.1859 15.0176C21.1859 15.7088 20.6272 16.2676 19.9359 16.2676Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M14.923 16.2676C14.2317 16.2676 13.668 15.7088 13.668 15.0176C13.668 14.3263 14.2205 13.7676 14.9117 13.7676H14.923C15.6142 13.7676 16.173 14.3263 16.173 15.0176C16.173 15.7088 15.6142 16.2676 14.923 16.2676Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M9.9125 16.2676C9.22125 16.2676 8.65625 15.7088 8.65625 15.0176C8.65625 14.3263 9.21 13.7676 9.90125 13.7676H9.9125C10.6037 13.7676 11.1625 14.3263 11.1625 15.0176C11.1625 15.7088 10.6037 16.2676 9.9125 16.2676Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props || $[7] !== size) {
    t5 = <Svg size={size} viewBox="0 0 30 30" {...props}>{t2}{t3}{t4}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}

/** Внешняя ссылка (вложение в чате). Figma: «link-external / Size=L · 24». */
export function ExternalLinkIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M13.0887 1.66406L17.5769 1.66406C17.7979 1.66406 18.0099 1.75187 18.1662 1.90817C18.3225 2.06447 18.4102 2.27645 18.4102 2.49748L18.4098 7.05419C18.4097 7.51443 18.0366 7.88749 17.5764 7.88744C17.1161 7.8874 16.7431 7.51427 16.7431 7.05403L16.7434 4.50944L7.09056 14.1622C6.76512 14.4877 6.23748 14.4877 5.91205 14.1622C5.58661 13.8368 5.58661 13.3092 5.91205 12.9837L15.565 3.33073H13.0887C12.6285 3.33073 12.2554 2.95763 12.2554 2.4974C12.2554 2.03716 12.6285 1.66406 13.0887 1.66406ZM6.46689 3.33316L8.42723 3.33316C8.88747 3.33316 9.26056 3.70625 9.26056 4.16649C9.26056 4.62673 8.88747 4.99983 8.42723 4.99983H6.5013C5.78749 4.99983 5.30224 5.00047 4.92717 5.03112C4.56182 5.06097 4.37499 5.11507 4.24465 5.18148C3.93105 5.34127 3.67608 5.59624 3.51629 5.90984C3.44988 6.04017 3.39578 6.22701 3.36593 6.59236C3.33528 6.96743 3.33464 7.45268 3.33464 8.16649V13.4998C3.33464 14.2136 3.33528 14.6989 3.36593 15.074C3.39578 15.4393 3.44988 15.6261 3.51629 15.7565C3.67608 16.0701 3.93105 16.325 4.24465 16.4848C4.37499 16.5512 4.56182 16.6053 4.92717 16.6352C5.30224 16.6658 5.78749 16.6665 6.5013 16.6665H11.8346C12.5485 16.6665 13.0337 16.6658 13.4088 16.6352C13.7741 16.6053 13.961 16.5512 14.0913 16.4848C14.4049 16.325 14.6599 16.0701 14.8196 15.7565C14.8861 15.6261 14.9402 15.4393 14.97 15.074C15.0007 14.6989 15.0013 14.2136 15.0013 13.4998V11.5739C15.0013 11.1137 15.3744 10.7406 15.8346 10.7406C16.2949 10.7406 16.668 11.1137 16.668 11.5739V13.5343C16.668 14.2051 16.668 14.7587 16.6311 15.2097C16.5929 15.6781 16.5107 16.1087 16.3047 16.5131C15.9851 17.1403 15.4751 17.6503 14.8479 17.9698C14.4435 18.1759 14.0129 18.2581 13.5445 18.2963C13.0935 18.3332 12.5399 18.3332 11.8691 18.3332H6.46687C5.79607 18.3332 5.24244 18.3332 4.79145 18.2963C4.32303 18.2581 3.89245 18.1759 3.488 17.9698C2.86079 17.6503 2.35086 17.1403 2.03128 16.5131C1.82521 16.1087 1.74307 15.6781 1.7048 15.2097C1.66795 14.7587 1.66796 14.2051 1.66797 13.5342V8.13208C1.66796 7.46127 1.66795 6.90763 1.7048 6.45664C1.74307 5.98822 1.82521 5.55764 2.03128 5.15319C2.35086 4.52598 2.86079 4.01605 3.488 3.69647C3.89245 3.49039 4.32303 3.40826 4.79145 3.36999C5.24244 3.33314 5.79608 3.33315 6.46689 3.33316Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Выйти: меню профиля. Figma: «logout 6 / Size=L · 24». */
export function LogoutIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.91219 2.15885L9.3928 2.25497C10.0496 2.38633 10.5958 2.49555 11.0397 2.61916C11.5038 2.7484 11.9234 2.91038 12.3091 3.17961C12.9135 3.60152 13.3896 4.18226 13.6848 4.85769C13.8731 5.28868 13.9497 5.73191 13.9854 6.21233C14.0196 6.67185 14.0195 7.22886 14.0195 7.8987V8.00012C14.0195 8.55241 13.5718 9.00012 13.0195 9.00012C12.4672 9.00012 12.0195 8.55241 12.0195 8.00012V7.93518C12.0195 7.21959 12.0189 6.73719 11.9909 6.36057C11.9638 5.99651 11.9149 5.80209 11.8522 5.65861C11.7046 5.3209 11.4665 5.03053 11.1643 4.81957C11.0359 4.72995 10.8549 4.64379 10.5032 4.54586C10.1394 4.44455 9.66647 4.34932 8.96477 4.20898L8.56477 4.12898C7.56307 3.92864 6.87526 3.79199 6.34058 3.73282C5.81452 3.6746 5.54732 3.7066 5.36566 3.76944C4.91535 3.92523 4.53545 4.23667 4.29438 4.64768C4.19713 4.81349 4.11335 5.06923 4.06727 5.59649C4.02043 6.13239 4.01953 6.83364 4.01953 7.85518V16.1451C4.01953 17.1666 4.02043 17.8679 4.06727 18.4038C4.11335 18.931 4.19713 19.1868 4.29438 19.3526C4.53545 19.7636 4.91535 20.075 5.36566 20.2308C5.54732 20.2936 5.81452 20.3256 6.34058 20.2674C6.87526 20.2083 7.56307 20.0716 8.56477 19.8713L8.96477 19.7913C9.66647 19.6509 10.1394 19.5557 10.5032 19.4544C10.8549 19.3565 11.0359 19.2703 11.1643 19.1807C11.4665 18.9697 11.7046 18.6794 11.8522 18.3416C11.9149 18.1982 11.9638 18.0037 11.9909 17.6397C12.0189 17.2631 12.0195 16.7807 12.0195 16.0651V16.0001C12.0195 15.4478 12.4672 15.0001 13.0195 15.0001C13.5718 15.0001 14.0195 15.4478 14.0195 16.0001V16.1015C14.0195 16.7714 14.0196 17.3284 13.9854 17.7879C13.9497 18.2683 13.8731 18.7116 13.6848 19.1426C13.3896 19.818 12.9135 20.3987 12.3091 20.8206C11.9234 21.0899 11.5038 21.2519 11.0397 21.3811C10.5958 21.5047 10.0496 21.6139 9.39281 21.7453L8.91207 21.8414C7.96619 22.0306 7.19246 22.1854 6.56057 22.2553C5.91008 22.3273 5.30022 22.3245 4.71178 22.1209C3.81116 21.8093 3.05137 21.1865 2.56923 20.3644C2.25421 19.8273 2.13185 19.2299 2.07486 18.5779C2.01951 17.9445 2.01952 17.1554 2.01953 16.1908V7.80947C2.01952 6.84481 2.01951 6.05571 2.07486 5.42235C2.13185 4.77038 2.25421 4.17291 2.56923 3.63582C3.05137 2.8138 3.81116 2.19092 4.71178 1.87935C5.30022 1.67578 5.91008 1.67297 6.56057 1.74495C7.19248 1.81488 7.96626 1.96965 8.91219 2.15885ZM16.066 6.45442C16.4786 6.08732 17.1107 6.12423 17.4778 6.53686L21.7469 11.3354C22.0841 11.7144 22.0841 12.2858 21.7469 12.6648L17.4778 17.4634C17.1107 17.876 16.4786 17.9129 16.066 17.5458C15.6533 17.1788 15.6164 16.5467 15.9835 16.134L18.7716 13.0001H10.3789C9.82662 13.0001 9.37891 12.5524 9.37891 12.0001C9.37891 11.4478 9.82662 11.0001 10.3789 11.0001H18.7716L15.9835 7.86623C15.6164 7.4536 15.6533 6.82151 16.066 6.45442Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Обновить/повторить в кнопке L («Повторить заказ»). Figma: «refresh 1 / Size=M · 20». */
export function Refresh20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.72958 3.91667C7.8878 3.91667 6.24572 4.76927 5.17531 6.10456C4.88745 6.46366 4.36298 6.5214 4.00388 6.23354C3.64478 5.94567 3.58703 5.42121 3.8749 5.06211C5.24802 3.34919 7.36072 2.25 9.72958 2.25C13.6382 2.25 16.8485 5.23999 17.198 9.05751L17.4876 8.73524C17.7953 8.39291 18.3221 8.36478 18.6645 8.6724C19.0068 8.98002 19.0349 9.50691 18.7273 9.84923L17.0563 11.7087C16.9086 11.8731 16.7016 11.9721 16.4809 11.9839C16.2602 11.9957 16.0439 11.9193 15.8795 11.7716L14.02 10.1006C13.6776 9.79297 13.6495 9.26608 13.9571 8.92376C14.2648 8.58143 14.7916 8.55329 15.134 8.86092L15.5397 9.22547C15.2744 6.24957 12.7745 3.91667 9.72958 3.91667ZM2.78562 8.42266C3.07463 8.06448 3.59928 8.00841 3.95746 8.29743L5.89294 9.85916C6.25112 10.1482 6.30719 10.6728 6.01817 11.031C5.72916 11.3892 5.20451 11.4452 4.84634 11.1562L4.49602 10.8736C5.01332 13.5458 7.36541 15.5637 10.1888 15.5637C11.7905 15.5637 13.2391 14.9154 14.2894 13.865C14.6148 13.5395 15.1425 13.5394 15.4679 13.8649C15.7934 14.1903 15.7934 14.7179 15.468 15.0434C14.1179 16.3937 12.2503 17.2303 10.1888 17.2303C6.49453 17.2303 3.427 14.5469 2.82904 11.0229L2.52096 11.4047C2.23195 11.7629 1.7073 11.819 1.34912 11.53C0.990946 11.241 0.934876 10.7163 1.22389 10.3581L2.78562 8.42266Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Возвраты: меню профиля. Figma: «Outline/refresh-square-2». */
export function RefreshSquareIcon(t0) {
  const $ = _c(11);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill="currentColor" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = strokeWidth ?? 1.5;
  let t4;
  if ($[5] !== t3) {
    t4 = <path d="M17.5 12C17.5 15.04 15.04 17.5 12 17.5C8.96 17.5 7.10999 14.44 7.10999 14.44M7.10999 17.19V14.44H9.59M6.5 12C6.5 8.96 8.94 6.5 12 6.5C15.67 6.5 17.5 9.56 17.5 9.56M15.06 9.56H17.5V6.81" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props || $[8] !== size || $[9] !== t4) {
    t5 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t4}</Svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}

/** Увеличить фото (кастомизация). Figma: «Maximize 2 / Size=16». */
export function MaximizeIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 10 : t1;
  const t2 = strokeWidth ?? 1;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M8.75 3.75V1.25H6.25M8.75 1.25L5.83333 4.16667M1.25 6.25V8.75H3.75M1.25 8.75L4.16667 5.83333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 10 10" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}